module.exports = __webpack_public_path__ + "img/-LV56RTziTqeOTgYa6I1.b1c94afe.jpg";